import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=6fed4f2d"
import script from "./SectionItem.vue?vue&type=script&lang=js"
export * from "./SectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports